module.exports = __webpack_public_path__ + "static/media/pythonb.e1d1f922.png";